import React from 'react';
import PropTypes from 'prop-types';
import Dialog from 'material-ui/Dialog';
import styled from 'styled-components';
import Button from 'components/button/ActionButton';
import DialogButton from 'components/button/DialogButton';
import utils from 'helpers/utils';
import Loader from 'components/loading/Loader';

const StyledWrapper = styled.div`
    display: block;
`;

const StyledButtonWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-end;
`;

const DialogLoader = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: rgba(255, 255, 255, 0.7);
`;

class GlobalModal extends React.Component {
    constructor(props) {
        super(props);

        const {
            dialog: {
                openOnInit,
            },
        } = props;

        this.actions = [];

        this.generateActions();

        this.state = {
            dialogOpen: openOnInit || false,
            isLoading: false,
        };
    }

    handleOpenDialog = () => {
        this.setState({
            dialogOpen: true,
        });
    }

    handleCloseDialog = () => {
        this.setState({
            dialogOpen: false,
            isLoading: false,
        });
    }

    handleLoadingOn = () => {
        this.setState({
            isLoading: true,
        });
    }

    handleLoadingOff = () => {
        this.setState({
            isLoading: false,
        });
    }

    generateActions = () => {
        const {
            dialog: {
                actions,
            },
        } = this.props;

        const result = [];

        actions.forEach((action) => {
            const {
                focus = false,
                label = '',
                onClick,
                onClose,
                primary = false,
            } = action;

            /**
             * Create the click function.
             *
             * This will validate if the onClick exists.
             * If it does exist, we will trigger the laoder and then resolve the onClick.
             */
            const onClickFunction = () => {
                if (!utils.isFunction(onClick)) {
                    return this.handleCloseDialog();
                }

                // We will always wait for 2 seconds.
                const triggerLoadingWithTimeOut = new Promise((resolve) => {
                    this.handleLoadingOn();

                    setTimeout(() => {
                        resolve();
                    }, 2000);
                });

                return Promise.all([
                    onClick(),
                    triggerLoadingWithTimeOut,
                ]).then(() => {
                    return this.handleCloseDialog();
                }).then(() => {
                    if (utils.isFunction(onClose)) {
                        onClose();
                    }

                    return;
                });
            };

            return result.push(<DialogButton
                keyboardFocused={ focus }
                key={ label }
                label={ label }
                onTouchTap={ onClickFunction }
                primary={ primary }
            />);

        });

        this.actions = result;
    }

    render() {
        const {
            button,
            children,
            dialog,
        } = this.props;

        const {
            dialogOpen,
            isLoading,
        } = this.state;

        return (
            <StyledWrapper>
                { utils.has(this.props, 'button') &&
                    <StyledButtonWrapper>
                        <Button
                            icon={ button.icon }
                            onClick={ this.handleOpenDialog }
                            title={ button.title ? button.title : null }
                            primary={ button.primary }
                        />
                    </StyledButtonWrapper>
                }

                <Dialog
                    actions={ this.actions }
                    actionsContainerStyle={ {
                        padding: '20px 20px 20px 0',
                    } }
                    bodyStyle={ {
                        padding: '0 20px',
                        margin: '20px 0',
                    } }
                    modal={ dialog.modal }
                    autoScrollBodyContent={ true }
                    autoDetectWindowHeight={ true }
                    onRequestClose={ this.handleDialogClose }
                    open={ dialogOpen }
                    overlayStyle={ {
                        backgroundColor: 'rgba(237, 236, 236, 0.6)',
                    } }
                    title={ dialog.title ? dialog.title : null }
                    titleStyle={ {
                        padding: '30px 20px 10px',
                        margin: '0',
                    } }
                >
                    { children }

                    { isLoading &&
                        <DialogLoader>
                            <Loader size={ 50 } />
                        </DialogLoader>
                    }
                </Dialog>
            </StyledWrapper>
        );
    }
}

GlobalModal.defaultProps = {
    button: {
        primary: false,
    },
    dialog: {
        modal: false,
        openOnInit: false,
    },
};

GlobalModal.propTypes = {
    button: PropTypes.shape({
        icon: PropTypes.node,
        primary: PropTypes.bool,
        title: PropTypes.string,
    }),
    children: PropTypes.node.isRequired,
    dialog: PropTypes.shape({
        actions: PropTypes.arrayOf(
            PropTypes.shape({
                focus: PropTypes.bool,
                label: PropTypes.string.isRequired,
                onClick: PropTypes.func,
                onClose: PropTypes.func,
                primary: PropTypes.bool,
                submit: PropTypes.func,
            }),
        ),
        modal: PropTypes.bool,
        openOnInit: PropTypes.bool,
        title: PropTypes.string,
    }).isRequired,
};

export default GlobalModal;



// WEBPACK FOOTER //
// ./src/components/modals/GlobalModal.js